import { render, staticRenderFns } from "./salesReturnEdit.vue?vue&type=template&id=f6c34654&scoped=true"
import script from "./salesReturnEdit.vue?vue&type=script&lang=js"
export * from "./salesReturnEdit.vue?vue&type=script&lang=js"
import style0 from "./salesReturnEdit.vue?vue&type=style&index=0&id=f6c34654&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c34654",
  null
  
)

export default component.exports